<style lang="scss">
    .GameLayoutCategoryCredit {
        position:relative;
        ul {
            overflow:hidden; border-bottom:2px solid #ccc; background:linear-gradient(to bottom,#f5f5f5,#c0c0c0);
            li {
                float:left; padding:.35rem .5rem; cursor:pointer;
                &:hover,&.active {
                    background-color:#fdb65c; background:linear-gradient(to bottom,#ffd8a5,#e78740); color:#e400ff;
                }
            }
            &.category-member {
                padding-right:290px;
            }
        }
        .category {
            position:relative; user-select:none;
            .btn {
                position:absolute; right:14px; top:8px;
                img {width:100px; height:33px;}
            }
        }
        .member-reload {
            position:absolute; right:10px; top:0; bottom:0;
            display:flex; align-items:center; white-space:nowrap; z-index:2;
            .el-button.reload-btn {
                color:#333; background-color:#94be39; border-color:#94be39; min-width:80px;
                &:focus, &:hover {
                    background:#81a92b; border-color:#81a92b; color:#333;
                }
                &.is-disabled {
                    background-color:#81a92b; border-color:#81a92b; color:#333;
                }
            }
        }
    }
</style>
<template>
    <nav v-show="Running.id" class="GameLayoutCategoryCredit">

        {{/* 管理员显示固定的导航 */}}
        <ul v-if="Opt.isTeam" class="category">
            <li v-for="(item,index) in LinkDir" v-if="item.enable" :class="{'active': $route.name.indexOf(item.name) >= 0}" @click="Go(item.name)">{{ item.title }}</li>
        </ul>

        <template v-else-if="Running.nav">
            {{/* 会员显示游戏列表 */}}
            <ul class="category category-member">
                <li v-for="(item,index) in Running.nav.list" :class="{'active': $route.name == 'credit/game' && Running.nav.item && Running.nav.item.id === item.id}" @click="ChangeCategory(item)">{{ item.title }}</li>
            </ul>
            <div v-if="isGamePage" class="member-reload">
                <span class="o-plr-s c-text-6">自动刷新</span>
                <el-select v-model="reload.interval" size="mini" style="width:80px;" @change="reloadIntervalChange">
                    <el-option label="禁用" :value="0" />
                    <el-option label="10秒" :value="10000" />
                    <el-option label="30秒" :value="30000" />
                    <el-option label="60秒" :value="60000" />
                </el-select>
                <el-button class="reload-btn o-ml-s" type="warning" size="mini" :loading="reload.loading" :disabled="reload.loading" @click="PageRefresh()">
                    刷新<span v-if="reload.interval && !reload.loading">({{ reload.down }})</span>
                </el-button>
            </div>
        </template>
    </nav>
</template>

<script>
import Common from './category.js'
export default {
    mixins: [Common],
    data() {
        return {
            gameActive: '',
            reload: {
                interval: 10000,
                timer: null,
                count: 0,
                down: 10,
                loading: false
            }
        }
    },
    computed: {
        isGamePage() {
            return this.$route.name === 'credit/game'
        },
        LinkDir() {
            if (this.User) {
                return [
                    {
                        name: 'credit/runtime',
                        title: '即时注单',
                        enable: this.CheckAuth(true,0)
                    },
                    {
                        name: 'credit/operate',
                        title: '操盘',
                        enable: this.CheckAuth(this.Opt.operate && this.Opt.operate.lhc && this.Opt.operate.lhc.manipulation, 1)
                    },
                    {
                        name: 'credit/transmit',
                        title: '走飞',
                        enable: this.CheckAuth(this.Opt.operate && this.Opt.operate.lhc && this.Opt.operate.lhc.transmit, 2)
                    },
                    {
                        name: 'credit/user',
                        title: '帐号管理',
                        enable: this.CheckAuth(true, 3)
                    },
                    {
                        name: 'credit/account',
                        title: this.Opt.isAdmin ? '公司' : '子帐号',
                        enable: this.CheckAuth(this.Opt.isTeam || this.Opt.isAdmin, 8)
                    },
                    {
                        name: 'credit/report',
                        title: '报表',
                        enable: this.CheckAuth(true, 6)
                    },
                    {
                        name: 'credit/open',
                        title: '开奖',
                        enable: this.CheckAuth(this.Opt.isAdmin, 7)
                    },
                    {
                        name: 'credit/actlog',
                        title: '操作日志',
                        enable: this.CheckAuth(true)
                    },
                    {
                        name: 'credit/password',
                        title: '修改密码',
                        enable: this.CheckAuth(!!this.User.is_subset)
                    },
                    {
                        name: 'credit/handicap',
                        title: '盘口设置',
                        enable: this.User.handicap_status == 1
                    },
                    {
                        name: 'credit/system',
                        title: '系统',
                        enable: this.CheckAuth(this.Opt.isAdmin, 9)
                    },
                    {
                        name: 'credit/betcancel',
                        title: '取消注单',
                        enable: this.User.pid === 1 && this.User.order_state === 1
                    },
                ]
            }
            return []
        }
    },
    watch: {
        'reload.interval'() {
            if (!this.Opt.isTeam) {
                this.AutoReloadRun()
            }
        },
        'Running.id'() {
            this.AutoReloadReset()
        },
        '$route.name'(name) {
            if (this.Opt.isTeam) return
            if (name === 'credit/game') {
                this.AutoReloadRun()
            } else {
                this.AutoReloadStop()
            }
        }
    },
    methods: {
        CheckAuth(origin, key) {
            if (!origin) {
                return false
            }
            if (this.Opt.isSub && key !== undefined) {
                if (!this.Opt.isSub[key]) {
                    return false
                }
            }
            return true
        },
        ChangeCategory(item) {
            if (this.Running.nav && this.Running.nav.loading) {
                return false
            }
            if (this.$route.name != 'credit/game') {
                this.Go('credit/game')
            }
            this.$emit('change', item)
        },
        ChangeGame(code) {
            this.$store.state.base.Event.emit('Credit/ChangeGame', code)
        },
        TryLoadReloadCache() {
            let interval = this.Cache('GameCredit_reload_interval')
            if (interval !== null && interval !== undefined && interval !== '') {
                const val = parseInt(interval)
                if (!isNaN(val)) {
                    this.reload.interval = val
                }
            }
        },
        reloadIntervalChange(val) {
            this.Cache('GameCredit_reload_interval', val)
        },
        AutoReloadRun() {
            this.AutoReloadStop()
            if (!this.reload.interval || this.Opt.isTeam || this.$route.name !== 'credit/game') {
                return
            }
            this.AutoReloadReset()
            const step = 250
            this.reload.timer = setInterval(() => {
                this.$set(this.reload, 'down', parseInt((this.reload.interval - this.reload.count) / 1000))
                this.reload.count += step
                if (this.reload.count > this.reload.interval) {
                    this.reload.count = 0
                    if (!this.reload.loading) {
                        this.PageRefresh()
                    }
                }
            }, step)
        },
        AutoReloadStop() {
            if (this.reload.timer) {
                clearInterval(this.reload.timer)
                this.reload.timer = null
            }
        },
        AutoReloadReset() {
            this.reload.count = 0
            this.$set(this.reload, 'down', this.reload.interval ? this.reload.interval / 1000 : 0)
        },
        PageRefresh() {
            if (this.reload.loading || !this.Running.id) {
                return Promise.resolve()
            }
            this.reload.loading = true
            const gamesId = this.Running.id
            return Promise.all([
                this.Dp('base/BASE_USER'),
                this.Dp('game/LIVE_GAME', {games_id: gamesId})
            ]).then(([, period]) => {
                if (period) {
                    this.$store.state.base.Event.emit('Credit/ExpectLoad', period)
                }
            }).catch(() => {}).finally(() => {
                this.reload.loading = false
                this.AutoReloadReset()
            })
        },
        initMemberReload() {
            if (this.Opt.isTeam) return
            this.TryLoadReloadCache()
            this.AutoReloadRun()
        }
    },
    created() {
        this.gameActive = this.Running.code
    },
    mounted() {
        this.initMemberReload()
    },
    beforeDestroy() {
        this.AutoReloadStop()
    }
}
</script>
